<template>
    <div class="settings">
        <!-- Tab content area -->

        <div class="col-sm-12 o-no-padding c-responsive-fixwidth">

            <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{$t('formatting')}}:</h2>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12">
                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">{{ $t('date_format') }}:</h6>
                                        <div class="o-cutsomSelect">
                                            <select v-model="employeeData.date_format" @change="dateSelect()" >
                                                <option v-for="(date,index) in dateFormat" :key="index" :value="date">{{date}}</option>
                                            </select>
                                        </div>
                                        <h6 class="h6 exampleDate">e.g.- {{exampleDate}}</h6>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-sm-12">
                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">{{ $t('time_format') }}:</h6>
                                      <!-- <p class="h5-v2">12 Hour Clock</p> -->
                                      <div class="o-cutsomSelect">
                                           <select v-model="employeeData.time_format" @change="timeSelect()">
                                                <option v-for="(time,index) in timeFormat" :key="index" :value="time">{{time}}</option>
                                            </select>
                                        </div>
                                        <h6 class="h6 exampleDate">e.g.- {{exampleTime}}</h6>
                                    </li>
                                </ul>
                            </div>

                            <!-- <div class="col-sm-6 o-left-padding-only">

                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">Phone format:</h6>
                                        <p class="h5-v2">xxxyyyzzzz</p>
                                    </li>
                                </ul>

                            </div> -->


                        </div>

                    </div>
                </div>
            </div>

            <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{ $t('car_pooling') }}</h2>
                            <p class="ps2">{{ $t('car_pooling_info1') + $t('car_pooling_info2') }}</p>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset">
                                    <li>
                                        <h6 class="h6">{{ $t('carpool') }}:</h6>
                                        <p class="h5-v2">{{ $t('i_cant_provide_transportation') }} </p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- #1548 Calendar Subscription (replaces the retired Nylas tab, #1516) -->
                        <div class="col-md-12">
                            <h2 class="h2">Calendar Subscription: <br /> <span class="user-spec">(subscribe your schedule in Apple, Google, or Outlook.)</span></h2>
                            <p class="ps2">
                                Subscribe to your CallSteward schedule from any calendar app. Your confirmed and pending
                                calls appear automatically and stay up to date — new calls, changes, and cancellations are
                                picked up whenever your calendar app refreshes its subscriptions (Apple and Outlook do this
                                on their own schedule, often a few hours). For real-time Google updates, use
                                <strong>Connect Google Calendar</strong> below. No per-event email and no extra subscription.
                            </p>
                            <p class="ps2">
                                <i class="fa fa-lock" aria-hidden="true"></i>
                                This link is private — anyone who has it can see your schedule. Keep it to yourself, and
                                use <strong>Reset link</strong> if it is ever shared by mistake.
                            </p>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">

                                <!-- Option A — Google (OAuth push, real-time write) #1519 -->
                                <div class="o-cal-option">
                                    <div class="o-cal-option-head">
                                        <i class="fa fa-google" aria-hidden="true"></i> Google Calendar
                                        <span class="o-cal-tag">real-time</span>
                                    </div>
                                    <div class="o-cal-google-row">
                                        <template v-if="!googleConnected">
                                            <el-button type="primary" size="small" :loading="googleBusy" @click="connectGoogle">
                                                <i class="fa fa-google" aria-hidden="true"></i> Connect Google Calendar
                                            </el-button>
                                            <span class="o-cal-feed-help">Push your confirmed calls into a "CallSteward" calendar in your Google account. Updates in real time.</span>
                                        </template>
                                        <template v-else>
                                            <span class="o-cal-google-status"><i class="fa fa-check-circle" aria-hidden="true"></i>
                                                Connected as {{ googleEmail }}<span v-if="googleLastSynced"> · synced {{ googleLastSynced }}</span></span>
                                        </template>
                                    </div>
                                </div>

                                <!-- Option B — Apple Calendar (subscribe; #1520) with non-Apple QR fallback (#1572) -->
                                <div class="o-cal-option">
                                    <div class="o-cal-option-head">
                                        <i class="fa fa-apple" aria-hidden="true"></i> Apple Calendar
                                        <span class="o-cal-tag">subscribe</span>
                                    </div>
                                    <el-button type="default" size="small" :loading="calBusy" @click="subscribeApple">
                                        <i class="fa fa-calendar-plus-o" aria-hidden="true"></i> Add to Apple Calendar
                                    </el-button>
                                    <span class="o-cal-feed-help">One-tap subscribe on iPhone, iPad, or Mac. Read-only; your device refreshes it on its own schedule. No password.</span>

                                    <!-- #1572 — on a non-Apple browser, don't dead-end: show a QR (scan with iPhone) + copy link -->
                                    <div v-if="appleFallback" class="o-cal-fallback">
                                        <p class="ps2"><strong>You're on a non-Apple device.</strong> Scan this code with your iPhone or iPad camera to subscribe, or copy the link and open it on your Apple device:</p>
                                        <div v-if="qrSvg" class="o-cal-qr" v-html="qrSvg" aria-label="Apple subscribe QR code"></div>
                                        <div class="o-cal-feed-row">
                                            <input type="text" class="form-control o-cal-feed-url" :value="calFeedUrl"
                                                readonly @focus="$event.target.select()" aria-label="Calendar subscription link" />
                                            <el-button type="primary" size="small" :disabled="!calFeedUrl" @click="copyFeedUrl">
                                                <i class="fa fa-clipboard" aria-hidden="true"></i> Copy
                                            </el-button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Option C — Manual ICS (Outlook / Yahoo / Thunderbird / anything) -->
                                <div class="o-cal-option">
                                    <div class="o-cal-option-head">
                                        <i class="fa fa-calendar" aria-hidden="true"></i> Outlook, Yahoo, or any calendar app
                                        <span class="o-cal-tag">subscribe</span>
                                    </div>
                                    <el-button v-if="!calFeedUrl" type="default" size="small" :loading="calBusy" @click="subscribeManual">
                                        <i class="fa fa-link" aria-hidden="true"></i> Get subscription link
                                    </el-button>
                                    <div v-else class="o-cal-feed-row">
                                        <input type="text" class="form-control o-cal-feed-url" :value="calFeedUrl"
                                            readonly @focus="$event.target.select()" aria-label="Calendar subscription link" />
                                        <el-button type="primary" size="small" :disabled="!calFeedUrl" @click="copyFeedUrl">
                                            <i class="fa fa-clipboard" aria-hidden="true"></i> Copy
                                        </el-button>
                                    </div>
                                    <span class="o-cal-feed-help">Add this URL as a subscribed / Internet calendar in Outlook, Yahoo, Thunderbird, and similar. Read-only.</span>
                                </div>

                                <!-- Reset — shows ONLY after at least one link is established -->
                                <div v-if="linkEstablished" class="o-cal-reset">
                                    <el-button type="warning" size="small" :loading="calResetting" @click="resetCalendar">
                                        <i class="fa fa-refresh" aria-hidden="true"></i> Reset calendar links
                                    </el-button>
                                    <span class="o-cal-feed-help">Stops all your current calendar links (Apple, Outlook/Yahoo, and Google). You'll need to re-add them.</span>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{ $t('job_notifications') || 'Job Notifications' }}:</h2>
                            <p class="ps2">{{ $t('select_notify_channel') }} </p>
                            <p v-if="clientData && clientData.suppress_sms" style="color: #e6a23c; font-size: 12px; margin-top: 4px;"><i class="fa fa-exclamation-triangle"></i> SMS notifications disabled at client level</p>
                        </div>
                        <div v-if="!clientData" class="col-sm-12 text-center" style="padding: 15px;"><i class="fa fa-spinner fa-spin"></i></div>
                        <div v-else class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset c-skillset--profile">

                                    <li>
                                       <div class="radio o-custom-radio">
                                            <!-- <label>
                                                <input type="radio" name="notifyChck" value="app" v-model="pickedNotify" @change="changeNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('app')}}
                                            </label> -->
                                            <el-switch
                                                v-model="notifyApp"
                                                active-color="#13ce66"
                                                inactive-color="#dcdfe6"
                                                :active-value = 1
                                                :inactive-value = 0
                                                @change="changeNotifyToApp()"
                                                >
                                            </el-switch>
                                                {{ $t('push_notifications') || 'Push Notifications' }}
                                                <span v-if="notifyApp && browserPushState === 'denied'" style="color:#F56C6C; font-size:12px;">(Blocked — enable in browser settings)</span>
                                        </div>
                                        <!-- <div class="checkbox o-custom-radio">
                                            <label>
                                                APP
                                                <input type="checkbox" name="o4" v-model="employeeData.app_notification" @change="changeAppNotification()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div> -->
                                    </li>
                                    <li>
                                        <div class="radio o-custom-radio">
                                            <!-- <label>
                                                <input type="radio" name="notifyChck" value="email" v-model="pickedNotify" @change="changeNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('email_primary') }}
                                            </label> -->
                                            <el-switch
                                                v-model="notifyEmail"
                                                active-color="#13ce66"
                                                inactive-color="#dcdfe6"
                                                :active-value = 1
                                                :inactive-value = 0
                                                @change="changeNotifyToEmail()"
                                                >
                                            </el-switch>
                                                {{$t('email_primary') }}
                                        </div>

                                        <!-- <div class="checkbox o-custom-radio">
                                            <label>
                                                Email(primary)
                                                <input type="checkbox" name="o4" v-model="employeeData.email_notification" @change="emailNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div> -->

                                    </li>
                                    <li v-if="!isCallstewardUK()">
                                       <div class="radio o-custom-radio">
                                            <!-- <label>
                                                <input type="radio" name="notifyChck" value="sms" v-model="pickedNotify" @change="changeNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('sms_cell')}}
                                            </label> -->
                                            <el-switch
                                                v-model="notifySms"
                                                active-color="#13ce66"
                                                inactive-color="#dcdfe6"
                                                :active-value = 1
                                                :inactive-value = 0
                                                :disabled="!!(clientData && clientData.suppress_sms)"
                                                @change="changeNotifyToSms()"
                                                >
                                            </el-switch>
                                                    {{$t('sms_cell') }}
                                                    <span v-if="clientData && clientData.suppress_sms" style="color: #999; font-size: 11px;">(disabled by admin)</span>
                                        </div>

                                        <!-- <div class="checkbox o-custom-radio">
                                            <label>
                                                SMS(cell)
                                                <input type="checkbox" name="o4" v-model="employeeData.sms_notification" @change="smsNotificationSettings()">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div> -->

                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-12">
                                <h2 class="h2" v-if="isCallstewardUK()">Stop Email:</h2>
                                <h2 class="h2" v-else> {{ $t('stop_email_sms') }}: </h2>
                                <!-- <p class="ps2">Do you want to stop receive email and sms?.</p>
                                <el-switch
                                    v-model="notifyLock"
                                    @change="notifyStartStop()"
                                    style="display: block"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6">
                                </el-switch> -->
                            </div>
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset c-skillset--profile">


                                    <li>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                <input type="radio" name="notifStop" :value="false" v-model="notifyLock" @change="notifyStartStop()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('receive') }}
                                            </label>
                                        </div>

                                    </li>
                                    <li>
                                       <div class="radio o-custom-radio">
                                            <label>
                                                <input type="radio" name="notifStop" :value="true" v-model="notifyLock" @change="notifyStartStop()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('stop') }}
                                            </label>
                                        </div>

                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-md-12">

                        </div>

                        <!-- <div class="col-md-12" v-if="getLogsAccess()">
                            <div>
                                <h2 class="h2">{{ $t('navigation_history') }}: </h2>
                                <p class="ps2">{{ $t('navigation_notification_note') }} </p>
                            </div>
                            <div class="o-employe-view">
                                <a href="javascript: void(0)" @click="notifyHistory()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-eye" aria-hidden="true"></i>{{ $t('click_to_view') }} </a>
                            </div>
                        </div> -->

                                <!-- <p class="ps2">{{ $t('navigation_notification_note') }} </p> -->
                        <!-- <div class="col-md-12" v-if="mailing_list_visibility_flag">
                            <div>
                                <h2 class="h2">Announcements from other IATSE Locals: </h2>
                            </div>
                            <div class="o-employe-view">
                                <el-switch
                                    v-model="mailing_action"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6"
                                    :active-value = 1
                                    :inactive-value = 0
                                    @change="changeMailingAction()"
                                    >
                                </el-switch>
                                An Email List
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>

            <!-- <div class="col-sm-4 o-right-padding-only">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">{{$t('login_options')}}:</h2>
                        </div>
                        <div class="col-sm-12 o-no-padding o-running-strip o-running-strip--profile">
                            <div class="col-sm-12 o-left-padding-only">
                                <ul class="c-skillset c-skillset--profile">

                                    <li>
                                       <div class="radio o-custom-radio">
                                            <label>
                                                <input type="radio" name="twoFactorAuth" :checked="two_factor_auth" @click="changeSignInOptions2fa()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span> {{ $t('2fa_authentication') }}
                                            </label>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                <input type="radio" name="fingerPrintAuth" :checked="finger_print_auth" @click="changeSignInOptionsFpa()">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                {{ $t('finger_print_authentication') }}
                                                {{ $t('google_ios_authorization') }}
                                            </label>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-sm-3 o-no-padding">
                <div class="c-common-space c-common-box-shadow c-radius3">
                    <div class="c-user-tab-content clearfix o-skillset-area o-profile-boxAppend">
                        <div class="col-md-12">
                            <h2 class="h2">Notifications:</h2>
                            <p class="ps2">Your .ics calendar file is located at:</p>
                        </div>
                        <div class="col-md-12">
                            <div class="o-employe-view">
                                <a href="#" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-download" aria-hidden="true"></i> Download</a>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <p class="ps2">If shifts are imported incorrectly, try the UTC calendar:</p>
                        </div>
                        <div class="col-md-12">
                            <div class="o-employe-view">
                                <a href="#" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-download" aria-hidden="true"></i> Download</a>
                            </div>
                        </div>

                    </div>
                </div>
            </div> -->

        </div>

        <!-- /Tab content area -->

        <!-- Push Notification Pre-Prompt Dialog -->
        <el-dialog
            :visible.sync="showPushPrompt"
            width="420px"
            :close-on-click-modal="false"
            custom-class="push-prompt-dialog"
            center>
            <div style="text-align:center; padding: 10px 0;">
                <i class="fa fa-bell" style="font-size: 48px; color: #13ce66; margin-bottom: 16px; display:block;"></i>
                <h3 style="margin-bottom: 12px; font-size: 18px;">Enable Push Notifications</h3>
                <p style="color: #606266; font-size: 14px; line-height: 1.6; margin-bottom: 8px;">
                    Get real-time job alerts and updates delivered directly to this browser — even when the tab is in the background.
                </p>
                <p style="color: #909399; font-size: 12px;">
                    You can disable this anytime from your settings.
                </p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="declinePushPrompt" size="medium">Not Now</el-button>
                <el-button type="success" @click="acceptPushPrompt" size="medium">Enable Notifications</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
    // import { global } from '../../global.js';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    // import { StripeCheckout } from '@vue-stripe/vue-stripe';
    // import { StripeCheckout } from '@vue-stripe/vue-stripe';
    import { loadStripe } from '@stripe/stripe-js';
    import { mapGetters } from 'vuex';
    // import { bus } from '../../main';
    import { requestNotificationPermission, getNotificationPermissionState } from '../../utils/firebase-messaging';
    // #1572 — client-side QR (pure-JS SVG, no canvas). The feed token is private,
    // so the QR is generated locally; the URL is NEVER sent to a 3rd-party QR API.
    import QRCode from 'qrcode';

    export default {
        components: {
            // StripeCheckout
        },
        data() {
            return {
                stripe: null,
                stripe_customer_id: '',
                is_nylas_subscription_active: false,
                nylas_subscription: null,
                stripe_subscription: null,
                employeeEmail: '',
                dataAvailable: false,
                lineItems:
                {
                    price: 'price_1KdwUrJTPH63iEDVOSzQU9ui', // The id of the recurring price you created in your Stripe dashboard
                    quantity: 1
                },
                successURL: window.location.href.split('#')[0]+"#/stripe-success",
                cancelURL: window.location.href,
                loading: false,
                // publishableKey: 'pk_live_51KUWweJTPH63iEDVnKZLaeCLWmgWvyHqU6MZZPjKZ8bb9s5tEt0mEyvyaZIqRowCF5zq08T1qZpm2YTXAKMtlRkr0004NOpe00',
                publishableKey: 'pk_test_51KUWweJTPH63iEDVqvqaGAnZEGmq5j1sBWwaJN5jv5aD7tJmurH3x7kpOro0HSxyjAhKAJbNJmDsQsU9uunmZMVo00ynpHuSnW',
                able_to_access_logs: null,
                notifyApp: false,
                notifyEmail: false,
                notifySms: false,
                browserPushState: getNotificationPermissionState(),
                showPushPrompt: false,
                two_factor_auth: false,
                finger_print_auth: false,
                pickedNotify: 'sms',
                notifyLock:true,
                ics_link:'',
                exampleDate: moment(Date.now()).format("DD MMMM YYYY"),
                dateFormat: [
                    "MM-DD-YY",
                    "MM/DD/YYYY",
                    "MMM DD YYYY",
                    "MMMM DD YYYY",
                    "DD-MM-YY",
                    "DD-MM-YYYY",
                    "DD MMM YYYY",
                    "DD MMMM YYYY",
                    "YYYY-MM-DD",
                    "YYYY MMM DD",
                    "YYYY MMMM DD",
                ],
                exampleTime: moment(Date.now()).format("hh:mm a"),
                timeFormat: [
                    "hh:mm a",
                    "HH:mm",
                ],
                selectDate: '',
                selectTime: '',
                employeeData: [],
                mailing_action: false,
                clientData: null,
                mailing_list_visibility_flag: false,
                // #1548 / #1571 / #1572 Calendar Subscription (opt-in)
                calFeedUrl: '',          // set only after explicit connect or if already established
                calBusy: false,          // opt-in action (Apple/Manual) in flight
                calResetting: false,     // Reset in flight
                appleFallback: false,    // non-Apple browser → show QR + copy instead of webcal dead-end
                qrSvg: '',               // client-side QR (SVG markup) for the fallback
                // #1519 Google push
                googleConnected: false,
                googleEmail: '',
                googleLastSynced: '',
                googleBusy: false
            }
        },
        props: {
            // userProfile: {
            //     type: Object,
            //     required: true
            // }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userRoleSlug: 'userRoleSlug',
                userClientID: 'userClientID',
                employeeId: 'employeeId',
                currentEmployeeID: 'currentEmployeeID',
                // getNotificationType: 'getNotificationType',
                userID: 'userID',
                getNylasUserEmail: 'getNylasUserEmail'
            }),
            // #1548 — webcal:// deep-link for Apple/Outlook one-tap subscribe.
            webcalUrl() {
                return this.calFeedUrl ? this.calFeedUrl.replace(/^https?:\/\//i, 'webcal://') : '';
            },
            // #1571 — a link is "established" once the ICS feed exists (token minted)
            // OR Google is connected. The Reset control appears only when true.
            linkEstablished() {
                return !!this.calFeedUrl || this.googleConnected;
            }
            // #1558 — removed googleAddUrl (ICS "add by URL"); superseded by the
            // #1519 Connect Google Calendar OAuth instant push above.
        },
        methods: {
            // ── #1548 Calendar Subscription ──────────────────────────────
            calFeedHeaders() {
                return {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                };
            },
            // ── #1519 Google direct push ─────────────────────────────────
            async loadGoogleStatus() {
                try {
                    const res = await service.getUrl('/api/v3/calendar-google/status', this.calFeedHeaders());
                    const r = (res && res.data && res.data.result) || {};
                    this.googleConnected = !!r.connected;
                    this.googleEmail = r.email || '';
                    this.googleLastSynced = r.last_synced ? new Date(r.last_synced).toLocaleString() : '';
                } catch (e) { console.log('loadGoogleStatus error:', e); }
            },
            async connectGoogle() {
                this.googleBusy = true;
                try {
                    const returnUrl = window.location.href;
                    const res = await service.getUrl('/api/v3/calendar-google/connect?return_url=' + encodeURIComponent(returnUrl), this.calFeedHeaders());
                    const url = res && res.data && res.data.result && res.data.result.auth_url;
                    if (url) { window.location.href = url; } // full redirect into Google's account picker
                    else { this.$notify.error({ title: 'Error', message: 'Could not start Google connect.' }); }
                } catch (e) {
                    this.$notify.error({ title: 'Error', message: 'Could not start Google connect.' });
                } finally { this.googleBusy = false; }
            },
            // ── #1571 opt-in ICS feed ────────────────────────────────────
            // Panel load: a NON-minting status read. Opening Settings must never
            // provision a feed — a token is minted only on an explicit connect
            // (subscribeApple / subscribeManual → ensureFeed).
            async loadCalendarStatus() {
                try {
                    const res = await service.getUrl('/api/v3/calendar-feed/status', this.calFeedHeaders());
                    const r = (res && res.data && res.data.result) || {};
                    this.calFeedUrl = (r.established && r.feed_url) ? r.feed_url : '';
                } catch (e) { console.log('loadCalendarStatus error:', e); }
            },
            // The explicit opt-in act: mint + publish the feed, then cache its URL.
            async ensureFeed() {
                if (this.calFeedUrl) return this.calFeedUrl;
                const res = await service.getUrl('/api/v3/calendar-feed', this.calFeedHeaders());
                this.calFeedUrl = (res && res.data && res.data.result && res.data.result.feed_url)
                    ? res.data.result.feed_url : '';
                return this.calFeedUrl;
            },
            // Apple platform probe (#1572): macOS / iOS / iPadOS (which reports as
            // Macintosh). Anything Windows/Android is explicitly non-Apple.
            isApplePlatform() {
                const ua = navigator.userAgent || '';
                const plat = navigator.platform || '';
                if (/Windows|Android/i.test(ua)) return false;
                return /iPhone|iPad|iPod|Macintosh|Mac OS X/i.test(ua) || /iPhone|iPad|iPod|Mac/i.test(plat);
            },
            // Apple: on an Apple device fire the webcal one-tap; on a non-Apple
            // browser DON'T dead-end — show a QR (scan with iPhone) + copy link.
            async subscribeApple() {
                this.calBusy = true;
                try {
                    await this.ensureFeed();
                    if (!this.calFeedUrl) {
                        this.$notify.error({ title: 'Error', message: 'Could not create your calendar link.' });
                        return;
                    }
                    if (this.isApplePlatform()) {
                        this.appleFallback = false;
                        window.location.href = this.webcalUrl; // one-tap subscribe in Apple Calendar
                    } else {
                        await this.showAppleFallback();
                    }
                } catch (err) {
                    console.log('subscribeApple error:', err);
                    this.$notify.error({ title: 'Error', message: 'Could not start the Apple subscription.' });
                } finally {
                    this.calBusy = false;
                }
            },
            // Build the QR locally (private token never leaves the browser) and
            // reveal the non-Apple fallback panel.
            async showAppleFallback() {
                try {
                    this.qrSvg = await QRCode.toString(this.webcalUrl, {
                        type: 'svg', margin: 1, width: 220, errorCorrectionLevel: 'M'
                    });
                } catch (e) {
                    console.log('QR generation failed:', e);
                    this.qrSvg = ''; // copy-link still works even if the QR can't render
                }
                this.appleFallback = true;
            },
            // Manual / other apps: opt in, then the URL row reveals automatically.
            async subscribeManual() {
                this.calBusy = true;
                try {
                    await this.ensureFeed();
                    if (!this.calFeedUrl) {
                        this.$notify.error({ title: 'Error', message: 'Could not create your calendar link.' });
                    }
                } catch (err) {
                    console.log('subscribeManual error:', err);
                    this.$notify.error({ title: 'Error', message: 'Could not create your calendar link.' });
                } finally {
                    this.calBusy = false;
                }
            },
            copyFeedUrl() {
                const url = this.calFeedUrl;
                if (!url) return;
                try {
                    navigator.clipboard.writeText(url);
                } catch (e) {
                    const el = document.createElement('textarea');
                    el.value = url;
                    document.body.appendChild(el);
                    el.select();
                    try { document.execCommand('copy'); } catch (ee) { /* ignore */ }
                    document.body.removeChild(el);
                }
                this.$notify({ title: 'Copied', message: 'Calendar link copied to your clipboard.', type: 'success' });
            },
            // #1571 — single Reset: stops ALL of this user's calendar links. Deletes
            // the ICS feed object + nulls the token (Apple/Outlook subscriptions stop
            // resolving) AND disconnects Google. The user re-adds from scratch.
            resetCalendar() {
                this.$confirm(
                    "This stops all your current calendar links (Apple, Outlook/Yahoo, and Google). You'll need to re-add them. Continue?",
                    'Reset calendar links',
                    { confirmButtonText: 'Reset', cancelButtonText: 'Cancel', type: 'warning' }
                ).then(async () => {
                    this.calResetting = true;
                    try {
                        if (this.calFeedUrl) {
                            await service.postUrl('/api/v3/calendar-feed/disconnect', {}, this.calFeedHeaders());
                        }
                        if (this.googleConnected) {
                            await service.postUrl('/api/v3/calendar-google/disconnect', {}, this.calFeedHeaders());
                        }
                        this.calFeedUrl = '';
                        this.appleFallback = false;
                        this.qrSvg = '';
                        this.googleConnected = false;
                        this.googleEmail = '';
                        this.googleLastSynced = '';
                        this.$notify({ title: 'Calendar links reset', message: 'Your calendar links were removed. Re-add them anytime.', type: 'success' });
                    } catch (err) {
                        console.log('resetCalendar error:', err);
                        this.$notify.error({ title: 'Error', message: 'Could not reset your calendar links.' });
                    } finally {
                        this.calResetting = false;
                    }
                }).catch(() => { /* user cancelled */ });
            },
            sendNylasEvent(emp) {
                if(emp.employable.stripe_subscription&&emp.employable.nylas_subscription) {
                    console.log('Nylas Event');
                    service.post('employee/sendNylasTestEvent', { employee_id: emp.id }, {
                        'Authorization': this.userToken
                    })
                    .then((res) => {
                        console.log(res.data);
                        if(res.data.status_code == "1") {
                            this.$notify({
                                title: 'Success',
                                message:res.data.status_message + ' for ' + res.data.result.email_address,
                                type: 'success'
                            });
                        }else {
                            this.$notify({
                                title: 'Error',
                                message:res.data.status_message,
                                type: 'error'
                            });
                        }
                    }).catch((err) => {
                        console.log(err);
                        this.$notify.error({
                        title: 'Error!',
                        message: 'Something went wrong'
                    });

                    });
                }else if(!emp.employable.stripe_subscription&&!emp.employable.nylas_subscription){
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing Both Nylas and Stripe Subscriptions'
                    });
                }else if(!emp.employable.nylas_subscription) {
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing only Nylas Subscription'
                    });
                }else {
                    this.$notify.error({
                        title: 'Error!',
                        message: 'Missing only Stripe Subscription'
                    });
                }
            },
            async changeMailingAction() {
                let result = this.mailing_action ? 'subscribe' : 'unsubscribe';
                console.log(this.mailing_action, result);
                await service.put('employee/'+ this.userID + '/updateMailingList',{
                    mailing_action: result
                }, {
                    'Authorization': this.userToken
                }).then((res) => {
                    if(res.data) {
                        console.log(res.data);
                        this.$notify.success(
                            {
                                message: res.data.status_message,
                                title: 'Success'
                            }
                        );
                    }
                }).catch((err) => {
                    console.log(err);
                    this.$notify(
                        {
                            type: 'error',
                            message: 'Something went wrong',
                            title: 'Error'
                        }
                    );

                });
            },
            refreshSubscription() {
                // console.log("Refresh Nylas Subscription");
                this.$notify({
                    type: 'success',
                    title: this.$t('success'),
                    message: 'Nylas Integration Refreshed'
                });
            },

            tokenCreated(token) {
                setTimeout(()=>{
                    // self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();
                    console.log("Token Created ....................",token);
                },1000)

            },

            async submit () {
                // if(this.employeeEmail=='' || this.errors.has('email')) {
                //     this.$notify.error({
                //         message: "Valid Email is required to proceed",
                //         title: "Required"
                //     });
                //     return;
                // }
                // this.$store.dispatch('setNylasUserEmail', this.employeeEmail);
                // console.log(this.getNylasUserEmail);
                if(this.employeeData.employable.stripe_subscription) {
                    // You will be redirected to Nylas's integration page
                    await this.generateNylasLink();
                    // await this.getEmailProvider();
                }
            },

            async handleCheckout() {
                this.loading = true;
                if(this.employeeEmail=='' || this.errors.has('email')) {
                    this.$notify.error({
                        message: "Valid Email is required to proceed",
                        title: "Required"
                    });
                    return;
                }
                this.$store.dispatch('setNylasUserEmail', this.employeeEmail);
                console.log(this.employeeData);
                if(this.employeeData&&this.employeeData.employable&&this.employeeData.employable.stripe_subscription) {
                    // You will be redirected to Nylas's integration page
                    await this.generateNylasLink();
                    // await this.getEmailProvider();
                }else {
                    try {
                        let headers = {
                            // 'authorization': this.userToken
                        }
                        let body = {
                            // userId: this.userID, // Pass user-related data here
                            line_items: {
                                price: 'price_1Kb4d6JTPH63iEDVOv4sJ7jk', // The id of the recurring price you created in your Stripe dashboard
                                quantity: 1
                            },
                            success_url: this.successURL,
                            cancel_url: this.cancelURL,
                            customer_id: this.stripe_customer_id,
                            client_reference_id: this.userID,
                            allow_promotion_codes: "true"
                        }
                        console.log("Body: ......................", body);
                        const response = await service.post('employee/create-stripe-session', body, headers );
                        // console.log("Session ID: ......................", response.data);
                        const { sessionId } = response.data;
                        const { error } = await this.stripe.redirectToCheckout({ sessionId });
                        if (error) console.error('Stripe Checkout Error:', error);
                    } catch (error) {
                        console.error("Error during checkout:", error);
                    } finally {
                        this.loading = false;
                    }
                }
            },

            async getEmailProvider() {
                await service.get('employee/detectNylasProvider', {
                    'Authorization': this.userToken,
                    'email': this.getNylasUserEmail
                }).then(async(res) => {
                    if(res.data&&res.data.result&&res.data.result=='gmail') {
                        this.$router.push({
                            path: "/sign-in-with-google",
                            name: 'signInWithGoogle'
                        });
                    }else {
                        await this.generateNylasLink();
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },

            async cancelSubscription() {
                this.$confirm('Are you sure you would like to cancel the Subscription? ', 'Warning', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: 'warning'
                }).then(async() => {
                    // Cancel Stripe Subscription
                    await this.cancelStripeSubscription();

                    // Cancel Nylas Subscription
                    await this.cancelNylasSubscription();


                }).catch((error) => {
                    console.log(error);
                    this.getEmpDetails();
                });
            },

            async cancelNylasSubscription() {
                await service.post('employee/cancelNylasSubscription',{
                user_id: this.userID
                }, {
                    'Authorization': this.userToken
                }).then(async(res) => {
                    // console.log(res.data);
                    // this.getEmpDetails();
                    if(res.data) {
                        this.$notify({
                            type: 'success',
                            title: this.$t('success'),
                            message: res.data.status_message
                        });
                    }
                    await this.getEmpDetails();
                    this.dataAvailable = true;
                }).catch((err) => {
                    console.log(err);
                });
            },

            async cancelStripeSubscription() {
                this.dataAvailable = false;
                    await service.post('employee/cancelStripeSubscription',{
                    user_id: this.userID
                    }, {
                        'Authorization': this.userToken
                    }).then((res) => {
                        // console.log(res.data);
                        // this.getEmpDetails();
                        if(res.data) {
                            this.$notify({
                                type: 'success',
                                title: this.$t('success'),
                                message: res.data.status_message
                            });
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
            },

            async generateNylasLink() {
                await service.get('employee/authorizeNylas', {
                    'Authorization': this.userToken,
                    'user-id': this.userID,
                    'email': this.getNylasUserEmail
                }).then((res) => {
                    if(res.data&&res.data.result) {
                        window.location.href = res.data.result;
                        this.$notify({
                            type: 'success',
                            title: this.$t('success'),
                            message: 'Nylas Subscription Started. Thank you for being with us!'
                        });
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },

            getLogsAccess(){
                if(this.able_to_access_logs || this.userRoleSlug != 'employee'){
                    return true;
                }
                return false;
            },

            isCallstewardUK(){
                return dateTimeConvert.isCallstewardUK();
            },

            notifyStartStop(){
                var formData ={
                    'employee_id': this.employeeData.id,
                    'status': this.notifyLock
                };
                // console.log(formData);

                service.post('employee/stopNotificationSettings', formData, {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID
                }).then((res) => {
                    this.$message({
                        type: 'success',
                        message: 'Success.'
                    });
                }).catch((err) => {
                    console.log(err);
                });
            },

            notifyHistory(){
                this.$store.dispatch('setNotificationType', 'employeeHistoryAction');
                this.$router.push({
                    path: `/notifyLog/`+ btoa(this.employeeData.id)
                });
            },

            dateSelect() {
                var formData = {
                    'employee_id': this.employeeData.id,
                    'type': 'date',
                    'format_string': this.employeeData.date_format
                }
                this.exampleDate = moment(Date.now()).format(this.employeeData.date_format);
                service.post('employee/changeDateFormat', formData, {
                    'Authorization': this.userToken,

                    'ClientId': this.userClientID
                }).then((res) => {
                    //console.log(res);
                    this.$cookies.set("date_format", this.employeeData.date_format, "23h");
                }).catch((err) => {
                    console.log(err);
                });

            },

            generateLink(){
                service.get('call/calendar/'+this.employeeData.id, {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID
                }).then((res) => {
                    //console.log(res.data.result.calendar_file);
                    this.ics_link=res.data.result.calendar_file;

                }).catch((err) => {
                    console.log(err);
                    this.$message({
                        type: 'error',
                        message: 'File not found. '
                    });
                });
            },

            timeSelect() {
                var formData = {
                    'employee_id': this.employeeData.id,
                    'type': 'time',
                    'format_string': this.employeeData.time_format
                }
                this.exampleTime = moment(Date.now()).format(this.employeeData.time_format);
                service.post('employee/changeDateFormat', formData, {
                    'Authorization': this.userToken,
                    'ClientId': this.userClientID
                }).then((res) => {
                    //console.log(res);
                    this.$cookies.set("time_format", this.employeeData.time_format, "23h");
                }).catch((err) => {
                    console.log(err);
                });
            },

            changeNotificationSettings(){
                // console.log(this.pickedNotify);
                // if(this.pickedNotify=='email'){
                //     this.emailNotificationSettings();
                // }else{
                //     this.smsNotificationSettings();
                // }
                this.emailNotificationSettings();
                this.smsNotificationSettings();
                this.changeAppNotification();
                this.$store.dispatch('setNotificationType', this.pickedNotify);
            },

            changeNotifyToApp() {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    this.notifyApp = 1
                    return;
                }

                // When toggling ON, show pre-prompt if browser permission not yet decided
                if (this.notifyApp == 1 && this.browserPushState === 'default') {
                    this.showPushPrompt = true;
                }

                {
                    var formData = {
                        'status': this.notifyApp,
                        'employee_id': this.employeeData.id
                    };
                    service.post('employee/appNotificationSettings', formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                        //console.log(res);
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            acceptPushPrompt() {
                this.showPushPrompt = false;
                var self = this;
                requestNotificationPermission(this.userToken, this.userClientID)
                    .then(function () {
                        self.browserPushState = getNotificationPermissionState();
                        if (self.browserPushState === 'granted') {
                            self.$notify.success({
                                message: 'Browser notifications enabled',
                                title: self.$t('success')
                            });
                        }
                    });
            },
            declinePushPrompt() {
                this.showPushPrompt = false;
            },
            // emailNotificationSettings() {
            changeNotifyToEmail() {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    this.notifyEmail = 1
                    return;
                } else {
                    var formData = {
                        'status': this.notifyEmail,
                        'employee_id': this.employeeData.id
                    };
                    service.post('employee/emailNotificationSettings', formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                        //console.log(res);
                        //bus.$emit('onUpdateOrAdd', 'On update notifications settings');
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            // smsNotificationSettings() {
            changeNotifyToSms() {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    this.notifySms = 1
                    return;
                } else {
                    // console.log("Sms Notify Else")
                    var formData = {
                        'status': this.notifySms,
                        'employee_id': this.employeeData.id
                    };
                    service.post('employee/smsNotificationSettings', formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },

            changeSignInOptions2fa() {
                this.two_factor_auth = !this.two_factor_auth;

                var formData = {
                    'status': this.two_factor_auth ? 1 : 0,
                    'user_id': this.employeeData.employable.id
                };

                service.post('employee/twoFactorAuthSettings', formData, {
                    'Authorization': this.userToken,
                }).then((res) => {
                    this.$notify({
                        title: 'Success',
                        message: 'Login Option Updated',
                        type: 'success'
                    });
                }).catch((err) => {
                    this.$notify({
                        title: 'Error',
                        message: 'Something went Wrong',
                        type: 'error'
                    });
                    console.log(err);
                });
            },

            changeSignInOptionsFpa() {
                this.finger_print_auth = !this.finger_print_auth;
                // var formData = {
                //     'status': this.finger_print_auth ? 1 : 0,
                //     'user_id': this.employeeData.employable.id
                // };
                // console.log(formData);
            },

            async getEmpDetails() {
                // this.getBaseURL = global[0].IMAGE_URL;
                this.$Progress.start();
                await service.get('employee/' + this.employeeId, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        //this.employeeData = basic.data.result;
                        this.employeeData = res.data.result;
                        console.log("Employee: ....................",this.employeeData);
                        this.nylas_subscription = this.employeeData&&this.employeeData.employable&&this.employeeData.employable.nylas_subscription?this.employeeData.employable.nylas_subscription:null;
                        this.stripe_subscription = this.employeeData&&this.employeeData.employable&&this.employeeData.employable.stripe_subscription?this.employeeData.employable.stripe_subscription:null;

                        this.is_nylas_subscription_active=this.nylas_subscription?this.nylas_subscription.is_active:false;

                        this.employeeEmail = this.nylas_subscription && this.nylas_subscription.email_address ? this.nylas_subscription.email_address:'';

                        this.dataAvailable = true;
                        this.$forceUpdate();
                        // this.userImage = this.detailEmployee.employable;
                    }).catch((err) => {
                        console.log(err);
                    });
            },

            getMailingListStatus() {
                service.get('employee/'+ this.userID +'/checkUserSubscriptionStatus', {
                    'Authorization': this.userToken,
                })
                .then((res) => {
                    this.mailing_action=res.data;
                    console.log(res.data);
                    // this.getSettings();
                }).catch((err) => {
                    console.log(err);
                });
            },

            async getClientData() {
                var clientId = this.userClientID;
                if (!clientId && this.employeeData && this.employeeData.client_employee && this.employeeData.client_employee.client_id) {
                    clientId = this.employeeData.client_employee.client_id;
                }
                if (!clientId) {
                    console.warn('getClientData: no clientId available');
                    return;
                }
                await service.get('client/' + clientId, {
                'Authorization': this.userToken
                })
                .then((res) => {
                    this.clientData = res.data.result;
                    this.mailing_list_visibility_flag = this.clientData.mailing_list_visibility_flag;
                }).catch((err) => {
                    console.log('getClientData error:', err);
                });
            },
        },

        async created() {
            // Load employee data, client data, and Stripe in parallel
            var [empResult] = await Promise.all([
                this.getEmpDetails(),
                this.getClientData(),
                loadStripe(this.publishableKey).then(stripe => { this.stripe = stripe; })
            ]);
            this.stripe_customer_id = this.employeeData && this.employeeData.employable && this.employeeData.employable.stripe_customer_id ? this.employeeData.employable.stripe_customer_id : null;
            console.log("Stripe Customer Id ..............................",this.stripe_customer_id);
            this.able_to_access_logs = this.employeeData.employee_status.able_to_access_logs;
            this.notifyApp = this.employeeData.app_notification
            this.notifyEmail = this.employeeData.email_notification
            this.notifySms = this.employeeData.sms_notification
            this.two_factor_auth = this.employeeData.employable.two_factor_auth ? true : false;
            this.notifyLock=(this.employeeData.stop_notification==0)?false:true;
            this.getMailingListStatus();
            this.loadCalendarStatus(); // #1571 NON-minting read (opt-in): only show a link if already established
            this.loadGoogleStatus();   // #1519 Google connection status
            // #1519 — surface the OAuth callback outcome (?gcal=google_connected|google_error|google_denied)
            try {
                const gcal = new URLSearchParams(window.location.hash.split('?')[1] || window.location.search).get('gcal');
                if (gcal === 'google_connected') {
                    this.$notify({ title: 'Google connected', message: 'Your schedule now syncs to Google Calendar.', type: 'success' });
                } else if (gcal === 'google_error' || gcal === 'google_denied') {
                    this.$notify.error({ title: 'Google', message: 'Google Calendar connection did not complete.' });
                }
            } catch (e) { /* ignore */ }
        }
    }

</script>
<style scoped>
.notify-icon {
    margin:10px 10px 10px 0;
}
.nylas-logo {
    height: 25px;
    width: 60px;
    padding: 8px 5px 0;
}
.nylas-event {
    font-size: 16px;
    border-radius: 5px;
    text-decoration: none!important;
    padding: 12px 10px 5px;
    /* color: #8158b8!important;
    border: 1px solid #8158b8; */
}
.nylas-event.active {
    background-color: #8158b8!important;
    border: 1px solid #8158b8;
}
.nylas-event.active:hover {
    color: #8158b8!important;
    border: 1px solid #8158b8;
}

.user-spec {
    font-size: 14px;
    /* color: #3a89ce; */
    margin: 0;
    padding: 0;
}
.nylas-subscribe-button {
    margin: 15px 10px 10px 0;
    padding: 10px 20px;
    border: none;
    outline: none;
    background-color: #258325;
    color: #ffffff;
    font-size:13px;
    font-weight: bold;
    border-radius: 5px;
}
.nylas-cancel-block {
    /* margin: 15px 10px 10px 0; */
    display: flex;
    align-items: flex-start;
    flex-direction: row;
}
.nylas-subscription-label{
    padding: 6px 5px 10px 20px;
    margin-top: 10px;
    /* margin-bottom: 10px; */
    border: none;
    outline: none;
    background-color: #ffffff;
    color: #1f1e1e;
    font-size: 13px;
    font-weight: bold;
}
.nylas-cancel-button {
    padding: 10px 20px;
    margin: 10px;
    border: none;
    outline: none;
    background-color: #e7eee7;
    color: #1f1e1e;
    font-size: 13px;
    font-weight: bold;
    border-radius: 5px;
}
.nylas-refresh-button {
    /* margin: 15px 10px 10px 0; */
    margin: 10px;
    padding: 10px 20px;
    border: none;
    outline: none;
    background-color: #FB9803;
    color: #ffffff;
    font-size: 13px;
    font-weight: bold;
    border-radius: 5px;
}

/* #1548 Calendar Subscription panel */
.o-cal-feed-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 6px 0 12px;
}
.o-cal-feed-url {
    flex: 1 1 auto;
    min-width: 0;
    font-family: monospace;
    font-size: 12px;
    background-color: #f5f7fa;
    cursor: text;
}
.o-cal-feed-help {
    color: #909399;
    font-size: 12px;
}
/* #1571/#1572 — 3-option model + QR fallback */
.o-cal-option {
    padding: 10px 0;
    border-top: 1px solid #ebeef5;
}
.o-cal-option:first-of-type {
    border-top: none;
}
.o-cal-option-head {
    font-weight: 600;
    color: #303133;
    margin-bottom: 8px;
}
.o-cal-tag {
    display: inline-block;
    margin-left: 6px;
    padding: 1px 7px;
    border-radius: 10px;
    background: #ecf5ff;
    color: #409eff;
    font-size: 11px;
    font-weight: 500;
    vertical-align: middle;
}
.o-cal-google-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
}
.o-cal-google-status {
    color: #67c23a;
    font-size: 13px;
}
.o-cal-fallback {
    margin-top: 10px;
    padding: 12px;
    background: #f5f7fa;
    border-radius: 6px;
}
.o-cal-qr {
    width: 220px;
    max-width: 100%;
    margin: 8px 0;
}
.o-cal-qr >>> svg,
.o-cal-qr svg {
    width: 100%;
    height: auto;
    display: block;
    background: #fff;
}
.o-cal-reset {
    margin-top: 14px;
    padding-top: 12px;
    border-top: 1px solid #ebeef5;
}
</style>
